// Variables below should be read from process.env

const pageUrl = new URL(window.location.href);
const eventSignupId = pageUrl.searchParams.get('event_id');
const domain = process.env.REACT_APP_API_HOST;

const apiConfig = {
  eventSignupId,
  baseUrl: `${domain}/api/v1/conventions/events/${eventSignupId}`,
  baseUrlv2: `${domain}/api/v2/conventions/events/${eventSignupId}`,
  auth: {
    user: process.env.REACT_APP_API_BASIC_AUTH_USER,
    password: process.env.REACT_APP_API_BASIC_AUTH_PASSWORD,
  },
};

const imgix = {
  imgix_domain:
    process.env.REACT_APP_IMGIX_DOMAIN,
  s3_domain_to_replace: process.env.REACT_APP_S3_DOMAIN,
  imgix_parameters_main: '?w=180&h=270&fit=crop&crop=entropy&q=75',
  imgix_parameters_student: '?w=90&h=135&fit=crop&crop=entropy&q=75',
};

export default apiConfig;
export { domain, imgix };



// WEBPACK FOOTER //
// ./src/lib/env.js